import type { ProfileBody } from '@muzly/api-client';

import type { OnboardingAnswer } from '../onboarding/flow';

/**
 * 온보딩 답 → 서버 프로필 바디.
 *
 * 설문 단계 id 와 선택지 값이 서버 계약 이름과 같으므로(`SURVEY_STEPS`) 여기서 하는 일은
 * 셋뿐이다: **어느 키를 보낼지 정하고**, 출생연도를 숫자로 바꾸고, 설문 답이 아닌 `lang` 을
 * 끼워 넣는다. 값을 갈아 끼우는 매핑표는 없다 — 있으면 어휘를 통일한 의미가 없다.
 *
 * `environment`·`condition` 은 로컬 프로필에 없다(회차마다 다시 묻는 답이라 `PROFILE_KEYS`
 * 밖이다). 서버 프로필에는 있으므로, 그 답을 아는 자리(초기 설정 완료·진단 시작)가
 * 답 맵째 넘기면 여기서 같이 담긴다.
 */
const BODY_KEYS = [
  'nick',
  'gender',
  'experience',
  'style',
  'purpose',
  'environment',
  'condition',
] as const;

export const toProfileBody = (
  answers: Record<string, OnboardingAnswer>,
  lang: string,
): ProfileBody => {
  const body: ProfileBody = { lang };

  for (const key of BODY_KEYS) {
    const value = answers[key];
    // 다중 선택은 배열로 온다 — 서버 필드는 값 하나라 담지 않는다.
    if (typeof value === 'string' && value.length > 0) {
      body[key] = value;
    }
  }

  // 설문은 연도를 문자열로 고르지만 계약은 number 다. 숫자가 아니면 서버가 거절할
  // 값이므로 큐에 넣지 않는다.
  const birthYear = Number(answers.birthYear);
  if (typeof answers.birthYear === 'string' && Number.isFinite(birthYear)) {
    body.birthYear = birthYear;
  }

  return body;
};
